import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class ProductService extends BaseService {

    static url = "products";
    static apis = {
        that: this,
        deepSearch: this.url +'/search',
        suggestions: function(id) {
            return this.that.url +'/' + id +'/suggestions'
        },
        specs: function(id) {
            return this.that.url + '/' +id +'/specs'
        }
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("products");
    }

    deepSearch(data) {
        var that = this;
        var inUrlParams = (data != undefined) ? ApiHelper.buildInlineParams(data) : '';
        return new Promise((resolve, reject) => {
            that.axios({ url: ProductService.apis.deepSearch.concat(inUrlParams), authorization:false, method: "GET", showLoader: false })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    async getSuggestions(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: ProductService.apis.suggestions(id), authorization:false, method: 'get', showLoader: true }).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error.response)
            })
        })
    }

    async getSpecs(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: ProductService.apis.specs(id), method: 'get', authorization:false, showLoader: true }).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error.response)
            })
        })
    }

}

export default ProductService;